import { VARIANT_ITEM_CLICK } from 'common/components/product-variants/ducks/actions';
import { isProductSet, ProductBelong } from 'features/product-info';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { createAction } from 'typesafe-actions';
import { selectProductId } from '../selectors';

/**
 * Cобытие должно срабатывать при клике на вариант.
 *
 * @see https://docs.google.com/document/d/1qQ6_QglkwskDA8x5RIW20OnGONBvb-CXFHSidE0wZiY/edit
 */
export const gaClickVariant = createAction('GA:clickProduct')<{
  elementType: 'product';
  elementBlock: 'productDetail / variants' | 'komplektyDetail / variants'; // блок, в котором расположен элемент
  elementName: 'productPhotoLink'; // название элемента (productNameLink или productPhotoLink), если кликнули по названию/фото

  productName: string; // // название продукта, по которому кликнули
  productId: string; // артикул продукта, по которому кликнули
  productPrice: string; // стоимость единицы продукта
  productBelong: ProductBelong; // принадлежность товара : LeroyMerlinMarketplace - для товаров Маркетплейс, Longtail - для товаров longtail, LeroyMerlin - для товаров Леруа Мерлен
  komplektyId: string | null; // идентификатор комплекта (Передавать, если товар-комплект). Для обычных товаров не передавать этот параметр
}>();

function* putGaClickVariant(
  productName: string,
  productId: string,
  productPrice: string,
  productBelong: ProductBelong,
) {
  const isSet: boolean = yield select(isProductSet);
  const elementBlock = isSet ? 'komplektyDetail / variants' : 'productDetail / variants';

  const komplektyId: string | null = isSet ? yield call(selectProductId) : null;

  yield put(
    gaClickVariant({
      elementType: 'product',
      elementBlock,
      elementName: 'productPhotoLink',
      productName: productName,
      productId: productId,
      productPrice: productPrice,
      productBelong: productBelong,
      komplektyId,
    }),
  );
}

export function* runGaClickVariantDetector() {
  yield takeEvery(VARIANT_ITEM_CLICK, function* handle({ payload }: ReturnType<typeof VARIANT_ITEM_CLICK>) {
    const { displayedName, productPrice, productId, productBelong } = payload;
    const formattedProductBelong = productBelong === 'Step' ? 'LeroyMerlin' : 'LeroyMerlinMarketplace';
    yield putGaClickVariant(displayedName, productId, productPrice, formattedProductBelong);
  });
}
